// Marca de "este móvil tenía una mesa abierta hace poco".
//
// Cuando el personal cierra la mesa (cobro en el TPV, liberar mesa...) el
// token del cliente deja de valer y la API responde 401 sin más detalle, igual
// que con un acceso no válido. Si este dispositivo tuvo una sesión correcta
// hace poco, ese 401 significa que la visita ha terminado: se muestra la
// pantalla de agradecimiento en lugar de "No está autorizado".

const VISIT_KEY = 'ewu_customer_visit_v1';
const VISIT_MAX_AGE_MS = 6 * 60 * 60 * 1000;

export function markCustomerVisitActive(now = Date.now()) {
  try {
    localStorage.setItem(VISIT_KEY, String(now));
  } catch {
    // Sin almacenamiento se mostrará la pantalla genérica.
  }
}

export function hadRecentCustomerVisit(now = Date.now()) {
  try {
    const at = Number(localStorage.getItem(VISIT_KEY) || 0);
    return at > 0 && now - at <= VISIT_MAX_AGE_MS;
  } catch {
    return false;
  }
}

/** Destino cuando la API rechaza la sesión de mesa del cliente (401/403). */
export function rejectedCustomerSessionRoute() {
  return hadRecentCustomerVisit()
    ? { name: 'Unauthorized', query: { reason: 'closed' } }
    : { name: 'Unauthorized' };
}
